"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcppAuthorizedTransactionValidation = void 0;
class OcppAuthorizedTransactionValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // If entity.evse_id exists, validate that it has the correct type.
        if (entity.evse_id != undefined) {
            if (typeof entity.evse_id !== "number")
                return false;
        }
        // Validate entity.remote_start_id for existence and correct type.
        if (entity.remote_start_id == undefined)
            return false;
        if (typeof entity.remote_start_id !== "number")
            return false;
        // Validate entity.id_token for existence and correct type.
        if (entity.id_token == undefined)
            return false;
        if (typeof entity.id_token !== "string")
            return false;
        // Validate entity.id_token_type for existence and correct type.
        if (entity.id_token_type == undefined)
            return false;
        if (typeof entity.id_token_type !== "string")
            return false;
        // Validate entity.authorized_utc for existence and correct type.
        if (entity.authorized_utc == undefined)
            return false;
        if (!(entity.authorized_utc instanceof Date))
            return false;
        return true;
    }
}
exports.OcppAuthorizedTransactionValidation = OcppAuthorizedTransactionValidation;
